module.exports = __webpack_public_path__ + "img/60x30x96-Kit.4cdcad63.png";